import React from 'react';

function EmptyDiv() {
  return <div></div>;
}

export default EmptyDiv;
